"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputLabel = void 0;
var global_1 = require("../../global");
exports.MuiInputLabel = {
    defaultProps: {
        sx: {
            fontSize: "1rem",
            lineHeight: "24px",
        },
    },
    styleOverrides: {
        root: {
            color: "rgba(0, 0, 0 60)",
            "&.MuiInputLabel-root": {
                fontSize: "1rem",
                lineHeight: "24px",
            },
            "&.MuiInputLabel-filled": {
                marginTop: global_1.spacing[1],
            },
        },
    },
};
//# sourceMappingURL=input-label.js.map